<template>
  <div class="row">
    <div class="col table-responsive mb-4">
      <table v-if="type === 'form'" class="products table table-striped table-hover table-bordered">
        <tr>
          <th colspan="2">{{ __('Product') }}</th>
          <th>{{ __('Price') }}</th>
          <th>{{ __('Quantity') }}</th>
          <th>{{ __('Subtotal') }}</th>
        </tr>
        <tr v-for="product in products" :key="`product-item-${product.id}`">
          <td><img v-if="product.image" :src="product.image" class="img-rounded" style="max-height: 100px"></td>
          <td>{{ product.name }}</td>
          <td class="no-wrap">
            <div v-if="product.compare_at_price > product.price" class="compare-at-price">{{ money(product.compare_at_price) }}</div>
            <div :class="{'discounted': product.compare_at_price > product.price}">{{ money(product.price) }}</div>
          </td>
          <td>
            <input type="number"
                   class="form-control quantity font-bold"
                   min="0"
                   max="999"
                   v-model="product.quantity"
                   :class="{'is-invalid': validated && products.every(p => p.quantity == 0)}">
          </td>
          <td class="font-bold no-wrap">{{ money(product.price * product.quantity) }}</td>
        </tr>
      </table>

      <table v-else class="products table table-striped table-hover table-bordered">
        <tr>
          <th colspan="2">{{ __('Product') }}</th>
          <th>{{ __('Price') }}</th>
          <th></th>
        </tr>
        <tr v-for="product in products" :key="`product-item-${product.id}`">
          <td><img v-if="product.image" :src="product.image" class="img-rounded" style="max-height: 100px"></td>
          <td>{{ product.name }}</td>
          <td class="no-wrap">
            <div v-if="product.compare_at_price > product.price" class="compare-at-price">{{ money(product.compare_at_price) }}</div>
            <div :class="{'discounted': product.compare_at_price > product.price}">{{ money(product.price) }}</div>
          </td>
          <td class="font-bold no-wrap">
            <a :href="productUrl(product)" target="_blank" class="btn btn-primary">{{ __('Order') }}</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div v-if="type === 'form'" class="row mb-4">
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-9">
          <DiscountCode/>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <table class="cart-summary table table-striped table-bordered">
        <tr>
          <td>{{ __('Subtotal') }}</td>
          <td>{{ money(subtotal) }}</td>
        </tr>
        <tr v-if="discount.code">
          <td>{{ __('Discount') }}</td>
          <td v-if="discount.type === 'amount'" class="text-success">-{{ money(discountAmount) }}</td>
          <td v-else-if="discount.type === 'percent'">-{{ money(discountAmount) }} ({{ discount.value / 100 }}%)</td>
        </tr>
        <tr>
          <td>{{ __('Shipping') }}</td>
          <td v-if="shipping === 0" v-html="__('Free shipping')" class="text-success"></td>
          <td v-else>{{ subtotal > 0 ? money(shipping) : money(0) }}</td>
        </tr>
        <tr>
          <td>{{ __('Total') }}</td>
          <td class="font-bold">{{ money(total) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import DiscountCode from "@/components/DiscountCode";

export default {
  name: "Cart",

  components: {DiscountCode},

  computed: {
    type() {
      return this.$store.state.type;
    },

    currency() {
      return this.$store.state.currency;
    },

    products() {
      return this.$store.state.products;
    },

    shippingOption() {
      return this.$store.getters.shippingOption;
    },

    discount() {
      return this.$store.state.discount;
    },

    discountAmount() {
      if (this.discount.type === 'amount') {
        return this.discount.value;
      }

      if (this.discount.type === 'percent') {
        if (this.discount.products.length === 0) {
          // use discount for all products
          return this.subtotal * (this.discount.value/(100 * 100));
        } else {
          // use discount only on specified products
          const productsSubtotal = this.discount.products
            .map(code => this.products.find(p => p.code === code))
            .filter(i => i !== undefined)
            .reduce((sum, product) => sum + (product.price * product.quantity), 0);

          return productsSubtotal * (this.discount.value/(100 * 100));
        }
      }
      return 0;
    },

    subtotal() {
      return this.products
        .filter(p => p.quantity > 0)
        .reduce((sum, product) => sum + (product.price * product.quantity), 0);
    },

    shipping() {
      let shipping = null;

      // cash on delivery
      if (this.$store.state.form.payment_method === 'cash_on_delivery') {
        shipping = (this.subtotal >= this.shippingOption.freeOver && this.shippingOption.freeOverActive === true)
          ? 0
          : this.shippingOption.price;
      }
      // other shipping methods
      else if (this.shippingOption.shippingOptions) {
        const shippingOption = this.shippingOption.shippingOptions.find(i => i.value === this.$store.state.form.shipping_method_id);
        const shippingData = this.shippingOption.shippingOptionsData[shippingOption.name];

        shipping = (this.subtotal >= shippingData.freeOver && shippingData.freeOverActive === true)
          ? 0
          : shippingData.price;
      }

      // apply products weight index
      shipping += this.products.reduce((acc, product) => (product.weight_index - 1) * shipping, 0);

      return shipping;
    },

    total() {
      if (this.subtotal === 0) return 0;

      return this.subtotal + this.shipping - this.discountAmount;
    },

    validated() {
      return this.$store.state.validated;
    },
  },

  methods: {
    productUrl(product) {
      return `https://unikatshop.eu/${this.$store.state.config.locale}/product/${product.id}/${product.slug}`;
    },
  },
}
</script>
